import { Component, OnInit, TemplateRef, ElementRef, HostListener } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../environments/environment';
import { Title, Meta } from '@angular/platform-browser';
import { IndexService } from '../_Service/Index/index.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { SigninSignUpService } from '../_Service/UsersSignInSignUp/signin-sign-up.service';
import * as moment from 'moment-timezone';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-news-outer',
  templateUrl: './news-outer.component.html',
  styleUrls: ['./news-outer.component.css']
})
export class NewsOuterComponent implements OnInit {

  //Variable details(n)
  title: any;
  platform_name: any;
  platform_logo: any;
  platform_id: any;
  project_url: any;
  newsDetailsArr: any;
  news_id: any;
  news_key: any = '';
  timezone: any;
  videoPlayButton: any;
  newsDetailsLoader: boolean;
  meta_logo: any;
  mostViewedNewsArr: any;
  mostViewNewsLoader: boolean = false;
  emptyNewsDetails: boolean;
  pals_bg: any;
  description: any;
  leagueList: any;
  leagueLoader: boolean = false;
  modalRef: BsModalRef;
  user_details: any;
  user_profile_img: any;
  isDropup = true;
  share_icon: any;
  //End variable details(n)

  // Close the pop modal on back button click (D)
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }
  // Close the pop modal on back button click (D)

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private modalService: BsModalService,
    private _IndexService: IndexService,
    private route: Router,
    private paramsroutes: ActivatedRoute,
    private _SigninSignUp: SigninSignUpService,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private elementRef: ElementRef
  ) {
    this.platform_name = environment.platform_name;
    this.platform_logo = environment.platform_logo;
    this.meta_logo = environment.blog_img;
    this.platform_id = environment.platform_id;
    this.project_url = environment.project_url;
    this.pals_bg = environment.pals_bg;
    this.user_profile_img = environment.user_profile_img;
    this.share_icon = environment.share_icon;
    this.timezone = ''
    this.newsDetailsLoader = true;
    this.emptyNewsDetails = false;
    this.mostViewedNewsArr = [];
    this.videoPlayButton = 0;
    //Get login user time starmp and other browser info(n)
    this._IndexService.currentGeoDetails().subscribe(res => {
      if (res && res['geo'] && res['geo']['timezone']) {
        this.timezone = res['geo']['timezone'];
        //Get url parameter(n)
        // this.paramsroutes.queryParams.subscribe(params => {
        if (this.paramsroutes.snapshot.params && this.paramsroutes.snapshot.params['lable']) {
          this.title = '';

          if (this.paramsroutes.snapshot.params['lable']) {
            this.title = this.paramsroutes.snapshot.params['lable']

            //Login uer load url to redirect on login news details page(n)
            if (localStorage.getItem("token")) {
              this.route.navigateByUrl('/news/' + this.title);
            }

            let mostViewBlog =
            {
              platform_id: this.platform_id,
              search: '',
              page: ''
            }
            //Get breaking news details(n)
            this.mostViewNewsLoader = true;
            this._SigninSignUp.getNewsDetailsBreakingOuter(mostViewBlog).subscribe(res => {
              if (res && res['status_code'] == 200) {
                for (let i = 0; i < res['breaking_news'].length; i++) {
                  res['breaking_news'][i]['url'] = this.project_url + 'news/' + res['breaking_news'][i]['title_url'];
                  if (i + 1 == res['breaking_news'].length) {
                    this.mostViewedNewsArr = res['breaking_news'];
                  }
                }
              } else {
                this.toastr.error(res['message'], 'Error!');
              }

              this.getDetailsofnews();
              this.mostViewNewsLoader = false;
            }, (err) => {
              this.mostViewNewsLoader = false;
              if (err && err['message']) {
                this.toastr.error(err['message'], 'Error!');
              }
            });
            //End get breaking news details(n)        
          } else {
            this.route.navigate(['/news']);
          }

        }
      }

    });
    //End get login user time starmp and other browser info(n)
  }

  ngOnInit(): void {
    this.getNewsDetailsCount();
  }

  //Without login click every link open login redirect model(n)
  openModallogin(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm modal-dialog-centered' });
  }
  //Redirect to new list page(n)
  redirectToLogin() {
    this.modalRef.hide();
    this.route.navigate(['/login']);
  }
  //Get news details by title name(n)
  getDetailsofnews() {
    let newsDetails =
    {
      news_title: this.title
    }

    this.newsDetailsArr = [];
    this.newsDetailsLoader = true;
    this._IndexService.getNewsDetailsByTitle(newsDetails).subscribe(
      res => {
        if (res && res['status_code'] && res['status_code'] == 200) {
          if (res && res['news_details']) {
            res['news_details']['url'] = this.project_url + 'news/' + res['news_details']['title_url'];

            res['news_details']['url_share'] = this.project_url + 'news/' + res['news_details']['title_url'];

            this.newsDetailsArr = res['news_details'];
            if (res['news_details'] && res['news_details']['publishedAt'] && res['news_details']['publishedAt'] != '0000-00-00 00:00:00') {
              let created_at = moment(res['news_details']['publishedAt']).tz(this.timezone);
              let created_date = this.datePipe.transform(created_at, "dd MMM, yyyy");
              let created_time = this.datePipe.transform(created_at, "hh:mm a");
              res['news_details']['posted_time'] = created_date + ' at ' + created_time;
            }

            //Setting the title and meta tag of component page(D)
            if (this.newsDetailsArr['title']) {
              this.title = this.newsDetailsArr['title'].substring(0, 100);
            } else {
              if (this.newsDetailsArr['img_headline']) {
                this.title = this.newsDetailsArr['img_headline'].substring(0, 100);
              } else {
                this.title = '';
              }
            }

            if (this.newsDetailsArr['content']) {
              this.description = this.removeTags(this.newsDetailsArr['content']).substring(0, 160);
            } else {
              if (this.newsDetailsArr['caption']) {
                this.description = this.removeTags(this.newsDetailsArr['caption']).substring(0, 160);
              } else {
                this.description = '';
              }
            }

            this.titleService.setTitle(this.title);
            this.metaTagService.addTag({ name: 'keywords', content: this.title });
            this.metaTagService.addTag({ name: 'description', content: this.description });

            this.metaTagService.addTag({ name: 'robots', content: 'all' });

            this.metaTagService.addTag({ property: 'og:locale', content: 'en_US' });
            this.metaTagService.addTag({ property: 'og:card', content: 'summary_large_image' });
            this.metaTagService.addTag({ property: 'og:site_name', content: this.platform_name });
            this.metaTagService.addTag({ property: 'og:title', content: this.title });
            this.metaTagService.addTag({ property: 'og:description', content: this.description });
            this.metaTagService.addTag({ property: 'og:url', content: this.project_url + this.route.url });
            this.metaTagService.addTag({ property: 'og:image:width', content: '1200' });
            this.metaTagService.addTag({ property: 'og:image:height', content: '630' });
            this.metaTagService.addTag({ property: 'og:image:alt', content: this.description });

            this.metaTagService.addTag({ name: 'twitter:card', content: 'summary_large_image' });
            this.metaTagService.addTag({ name: 'twitter:site_name', content: this.platform_name });
            this.metaTagService.addTag({ name: 'twitter:title', content: this.title });
            this.metaTagService.addTag({ name: 'twitter:description', content: this.description });
            this.metaTagService.addTag({ name: 'twitter:url', content: this.project_url + this.route.url });
            this.metaTagService.addTag({ name: 'twitter:image:width', content: '800' });
            this.metaTagService.addTag({ name: 'twitter:image:height', content: '480' });
            this.metaTagService.addTag({ name: 'twitter:image:alt', content: this.description });


            if (this.newsDetailsArr['urlToImage'] && this.newsDetailsArr['urlToImage'] != "") {
              this.metaTagService.addTag({ property: 'og:image', content: this.newsDetailsArr['urlToImage'] });
              this.metaTagService.addTag({ name: 'twitter:image', content: this.newsDetailsArr['urlToImage'] });

            } else if (this.newsDetailsArr['profile_pic'] && this.newsDetailsArr['profile_pic'] != "") {
              if (this.newsDetailsArr['profile_pic']) {
                this.metaTagService.addTag({ property: 'og:image', content: this.newsDetailsArr['profile_pic'] });
                this.metaTagService.addTag({ name: 'twitter:image', content: this.newsDetailsArr['profile_pic'] });
              } else {
                this.metaTagService.addTag({ property: 'og:image', content: this.project_url + '' + this.meta_logo });
                this.metaTagService.addTag({ name: 'twitter:image', content: this.project_url + '' + this.meta_logo });
              }
            } else {
              this.metaTagService.addTag({ property: 'og:image', content: this.project_url + '' + this.meta_logo });
              this.metaTagService.addTag({ name: 'twitter:image', content: this.project_url + '' + this.meta_logo });
            }
            //End Setting the title and meta tag of component page(D)

            if (this.timezone) {
              this.newsDetailsLoader = false;
            } else {
              this.newsDetailsLoader = true;
            }
          } else {
            this.newsDetailsLoader = false;
            this.emptyNewsDetails = true;
          }
        } else {
          this.newsDetailsLoader = false;
          this.emptyNewsDetails = true;
          this.route.navigate(['/news']);
        }
      }, (err) => {
        this.newsDetailsLoader = false;
        this.emptyNewsDetails = true;
        if (err && err['message']) {
          this.route.navigate(['/news']);
        }
      });
  }
  //Encrypt Data(n)
  encryptData(data) {

    try {
      if (data) {
        return CryptoJS.AES.encrypt(JSON.stringify(data), '1234509876encryptdecrypt1234567890').toString();
      }
    } catch (e) {

    }
  }
  //Decrypt Data (n)
  decryptData(data) {
    try {
      const bytes = CryptoJS.AES.decrypt(data, '1234509876encryptdecrypt1234567890');
      if (bytes.toString()) {
        if (CryptoJS.enc.Utf8) {
          return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }
      }
      if (data) {
        return data;
      }
    } catch (e) {
      this.route.navigate(['/news']);
    }
  }
  //Post Text With media upload(n)
  playVideo(event: any, pmId): void {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {

    } else {
      if (event && event.target && event.target.previousElementSibling) {
        this.videoPlayButton = pmId;
        const playedPromise = event.target.previousElementSibling.play();
        if (playedPromise) {
          playedPromise.catch((e) => {
            if (e.name === 'NotAllowedError' ||
              e.name === 'NotSupportedError') {
            }
          });
        }
      }
    }
  }
  //On mouse remove video pause(n)
  pauseVideo(event: any, pmId): void {
    if (event && event.target) {
      event.target.pause();
      this.videoPlayButton = 0;
    }
  }
  //Get news count show with league(n)
  getNewsDetailsCount() {
    this.leagueLoader = true;
    this._SigninSignUp.getNewsDetailsCount().subscribe(
      res => {
        this.leagueList = res["news_detail_count"];
        this.leagueList = this.leagueList.map((elem)=>{
          if(elem.name == "IPL"){
             elem.name = "Cricket";
          }
          return elem
        });

        // console.log("with changes",data);
        // console.log("for test",this.leagueList);
        
        this.leagueLoader = false;
      }, (err) => {
        this.leagueLoader = false;
        this.route.navigate(['/news']);
      }
    );
  }
  //Load league name(n)
  filterByLeague(league) {
    // console.log(league)
    localStorage.setItem("league", this.encryptData(league));
    this.route.navigate(['/news']);
  }

  postUrlCopy() {
    let urlLink = window.location.href;
    if (urlLink) {
      let textarea;
      let result;
      
      try {
        textarea = document.createElement('textarea');
        textarea.setAttribute('readonly', true);
        textarea.setAttribute('contenteditable', true);
        textarea.value = urlLink;

        document.body.appendChild(textarea);

        textarea.select();

        const range = document.createRange();
        range.selectNodeContents(textarea);

        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        textarea.setSelectionRange(0, textarea.value.length);
        result = document.execCommand('copy');
      } catch (err) {
        result = null;
      } finally {
        document.body.removeChild(textarea);
      }

      // manual copy fallback using prompt
      if (!result) {
        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        const copyHotkey = isMac ? '⌘C' : 'CTRL+C';
        result = prompt(`Press ${copyHotkey}`, urlLink); // eslint-disable-line no-alert
        if (!result) {
          return false;
        }
      }
      this.toastr.success('News copy successfully', 'Success!', { timeOut: 1000 });

    }
  }


  //Remoe css and js loa landing page(n)
  removeTags(str) {
    if ((str === null) || (str === ''))
      return false;
    else
      str = str.toString();
    return str.replace(/(<([^>]+)>)/ig, '');
  }

  ngAfterViewInit() {
    this.elementRef.nativeElement.ownerDocument.body.style.background = this.pals_bg;
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundAttachment = "fixed";
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundSize = "cover";
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundPosition = "center";
  }

}
